import React, { ComponentType, FC, SVGProps } from 'react';
import { Amenity } from '../../../domain/models/Amenity';
import Local from '../../../../../../assets/icons/local.svg';
import Vegan from '../../../../../../assets/icons/vegan.svg';
import GlutenFree from '../../../../../../assets/icons/gluten-free.svg';
import Vegetarian from '../../../../../../assets/icons/vegetarian.svg';
import MobileOrdering from '../../../../../../assets/icons/mobile-ordering.svg';

type Svg = ComponentType<SVGProps<SVGSVGElement>>;

const AmenityIcons: Record<Amenity, Svg> = {
	'CLT Local': Local,
	vegan: Vegan,
	vegetarian: Vegetarian,
	'gluten free': GlutenFree,
	'mobile ordering': MobileOrdering,
};

export const AmenityIcon: FC<{ amenity: Amenity }> = ({ amenity }) => {
	const Icon = AmenityIcons[amenity];

	return <Icon aria-label={`${amenity} icon`} role="img" />;
};
